import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { WopiSettingsType } from './types';
import API from './API';

interface IPluginInfo {
	loading: 'idle' | 'pending' | 'succeeded' | 'failed';
	error?: string;
	enable: boolean;
	config?: WopiSettingsType | null;
}

const initialState: IPluginInfo = {
	loading: 'idle',
	enable: false,
	config: null,
};

export const getWopiConfig = createAsyncThunk('wopi/Get', async () => {
	const response = await API.getSettings();
	return response;
});

export const wopiSlice = createSlice({
	name: 'wopi',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getWopiConfig.pending, (state) => {
			state.loading = 'pending';
		});
		builder.addCase(getWopiConfig.fulfilled, (state, action) => {
			if (!!action.payload && typeof action.payload !== 'string') {
				return {
					enable: !action.payload.hasError,
					error: action.payload.hasError
						? (action.payload.errorMessage ?? undefined)
						: undefined,
					config: action.payload.result,
					loading: 'succeeded',
				};
			}
			return state;
		});
		builder.addCase(getWopiConfig.rejected, (state, action) => {
			state.error = action.error.message;
			state.loading = 'pending';
		});
	},
});

export const getWopiConfigSelector = (store: RootState): IPluginInfo => {
	return store.wopi;
};
